import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useFetchArticleStockRecommendations = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get(
            `paradigm/article-stock/list?stockSymbols=${data.stockSymbols}&eventDateFrom=${data.eventDateFrom}&eventDateTo=${data.eventDateTo}&isGuestUser=${data.isGuestUser}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}`);
    }, options);
};

export const useFetchArticleContent = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (model: any) => {
        const response = await get("paradigm/article-content?articleId=" + model.articleId);
        return response;
    }, options);
};

export const useFetchParadigmStocks = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("paradigm/stocks");
    }, options);
};